import { CommandButton } from "components";
import { TableSectionProps } from "pages/Purchase/Register/types";
import { convertNumber } from "utils";
import { exportExcel } from "../functions";
import { useExportPdf } from "../hooks";

export const FotherSection = ({ data, exportDateFormat }: TableSectionProps) => {
  const totalSubtotal = data.reduce((total, item) => total + item.sub_total, 0);
  const totalPayment = data.reduce((total, item) => total + item.payment, 0);
  const totalBalance = data.reduce((total, item) => total + item.balance_owing, 0);
  const exportPdf = useExportPdf({ data: data, dateFilter: exportDateFormat ?? "" })

  return (
    <div className="flex justify-between">
      <section className="flex flex-wrap gap-3">
        <CommandButton actiontype="export" onClick={() => exportExcel({
          data: data,
          dateFilter: exportDateFormat ?? ''
        })} />
        <CommandButton actiontype="pdf" onClick={exportPdf.handleExportPdf} />
      </section>

      <div>
        <div className="label-text font-bold flex justify-end text-right">
          <div>
            <div>SUMMARY SUBTOTAL</div>
            <div>SUMMARY PAYMENT</div>
            <div>SUMMARY BALANCE</div>
          </div>
          <div className="mx-2">
            <div>:</div>
            <div>:</div>
            <div>:</div>
          </div>
          <div>
            <div>{totalSubtotal ? convertNumber(totalSubtotal)?.intoCurrency : "0"}</div>
            <div>{totalPayment ? convertNumber(totalPayment)?.intoCurrency : "0"}</div>
            <div>{totalBalance ? convertNumber(totalBalance)?.intoCurrency : "0"}</div>
          </div>
        </div>
      </div>
    </div>
  )
}